const VedgeAnalyticsHandler = (function() {
  'use strict';

  const googleTagsPerDomain = {
    'vedge-dev-store.myshopify.com': {
      adwords: 'AW-11235376179',
      analytics: 'G-6JZGJ1WEK1',
      merchant: 'MC-CDH69LXZ5C',
    },
    'vedge-nutrition.myshopify.com': {
      adwords: 'AW-520301909/MJkECIn1zOMBENXajPgB',
      analytics: 'G-PF3DHF557T',
      merchant: 'MC-M22KLQ3732',
    },
  };

  return {
    pushViewItem,
    pushReachedCheckout
  };

  ////////////////////////////////////////////////////////////////////////////

  function pushViewItem(productId, variantId, price) {
    const tags = _getTags();
    const id = `shopify_US_${productId}_${variantId}`;

    gtag("event", "view_item", {
      send_to: [tags.adwords, tags.analytics, tags.merchant],
      ecomm_prodid: [id],
      ecomm_totalvalue: null,
      ecomm_pagetype: "product",
      items: [
        {
          id,
          price: price.toString(),
        }
      ]
    })
  }

  function shopifyItemId(productId, variantId) {
    return `shopify_US_${productId}_${variantId}`;
  }

  function cartLineToGa4Item(lineItem) {
    const unitPriceCents = Number(lineItem.final_price) || Number(lineItem.price) || 0;
    const variantTitle = lineItem.variant_title != null ? String(lineItem.variant_title).trim() : '';
    const itemId = shopifyItemId(lineItem.product_id, lineItem.variant_id);
    const ga4Item = {
      id: itemId,
      item_id: itemId,
      google_business_vertical: 'retail',
      item_name: lineItem.product_title || lineItem.title || '',
      price: unitPriceCents / 100,
      quantity: lineItem.quantity || 1,
    };
    if (lineItem.vendor) ga4Item.item_brand = lineItem.vendor;
    if (lineItem.product_type) ga4Item.item_category = lineItem.product_type;
    if (variantTitle && variantTitle !== 'Default Title') ga4Item.item_variant = variantTitle;
    return ga4Item;
  }

  function pushReachedCheckout(cart) {
    const tags = _getTags();
    if (!tags || typeof gtag !== 'function') return;

    const eventParams = {
      send_to: [tags.adwords, tags.analytics, tags.merchant],
      ecomm_pagetype: 'cart',
    };

    if (cart) {
      const cartTotalValue = (Number(cart.total_price) || 0) / 100;
      eventParams.value = cartTotalValue;
      eventParams.ecomm_totalvalue = cartTotalValue;
      eventParams.currency =
        typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active
          ? Shopify.currency.active
          : 'USD';
      if (Array.isArray(cart.items) && cart.items.length) {
        const ga4Items = cart.items.map(cartLineToGa4Item);
        eventParams.items = ga4Items;
        eventParams.ecomm_prodid = ga4Items.map(function (ga4Item) {
          return ga4Item.item_id;
        });

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'reached_checkout',
          currency: eventParams.currency,
          value: cartTotalValue,
          ecomm_pagetype: 'cart',
          ecomm_prodid: eventParams.ecomm_prodid,
          ecomm_totalvalue: cartTotalValue,
          items: ga4Items,
        });
      }
    }

    gtag('event', 'reached_checkout', eventParams);
  }

  ////////////////////////////////////////////////////////////////////////////

  function _getTags() {
    if (typeof Shopify === 'undefined' || !Shopify.shop) return null;
    return googleTagsPerDomain[Shopify.shop];
  }

})();

